import React, { useState, useEffect } from 'react'
import styles from './styles.module.css'
import useStore from '../../../StorePeople/Store'

export default function State() {
  const { state, setState, isQueryLoading } = useStore()
  // Local state to immediately reflect the input value
  const [localState, setLocalState] = useState(state)

  // Update the global state only after 1 second of no changes
  useEffect(() => {
    const timer = setTimeout(() => {
      setState(localState)
    }, 1000)

    // Clear the timeout if the user types again before 1 second passes
    return () => clearTimeout(timer)
  }, [localState, setState])

  // Synchronize local state when the global state changes externally
  useEffect(() => {
    setLocalState(state)
  }, [state])

  const handleStateChange = (event) => {
    setLocalState(event.target.value)
  }

  return (
    <div className={styles.statePeopleContainer}>
      <label className={styles.statePeopleLabel}>State</label>
      <input
        className={styles.statePeopleInput}
        type='text'
        id='prevent_autofill'
        autoComplete='off'
        placeholder='California'
        value={localState}
        disabled={isQueryLoading}
        onChange={handleStateChange}
      />
    </div>
  )
}
